import { clsx } from 'clsx';

import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';

import screenStyles from '../../RecipeScreen.module.scss';

import styles from './RecipeScreenSkeleton.module.scss';

export const RecipeScreenSkeleton = () => (
  <div className={styles.root} role="progressbar">
    <Skeleton width="60%" height={16} />

    <div className={styles.content}>
      <div className={clsx(screenStyles.grid, styles.grid)}>
        <div className={styles.nameAndTag}>
          <Skeleton width={40} height={24} />
          <Skeleton width={300} />
        </div>

        <Skeleton className={styles.skeletonImage} />

        <div className={styles.preparationInfos}>
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
          <Skeleton width={72} height={60} />
        </div>

        <div className={styles.picker}>
          <Skeleton height={24} width={134} />
          <Skeleton height={40} width={208} />
        </div>

        <div className={styles.shortDescription}>
          <Skeleton />
          <Skeleton width={100} />
        </div>
      </div>

      <div className={styles.productInformation}>
        <Skeleton width={90} />
        <Skeleton height={300} />
      </div>

      <div className={styles.additionalInformation}>
        <Skeleton width={150} />
        <Skeleton height={600} />
      </div>
    </div>
  </div>
);
